import {useMutation} from '@apollo/client';
import {Close} from '@mui/icons-material';
import {
  Button,
  Grid,
  IconButton,
  Modal,
  Slide,
  Typography,
} from '@mui/material';

import {Logo} from '../../../components/icons';
import Input from '../../../components/input/input';
import InputMask from '../../../components/input/input-mask';
import {toastNotification} from '../../../components/toastify';
import {tipoContato} from '../../../constants/enum-labels';
import {CONCLUIR_CONTATO} from '../../../graphql/mutation';
import Masks from '../../../utils/masks';

export default function ContatoModal({contato = {}, open, onClose}) {
  const [concluirContato] = useMutation(CONCLUIR_CONTATO);

  const handleConcluirContato = () => {
    concluirContato({
      variables: {
        contato: {
          id: contato?.id,
        },
      },
    })
      .then(() => {
        toastNotification({message: 'Solicitação concluída!', type: 'success'});
        onClose();
      })
      .catch((error) =>
        toastNotification({message: error.message, type: 'error'}),
      );
  };

  return (
    <Modal open={open} onClose={onClose} sx={styles.modal}>
      <Slide in={open} appear>
        <Grid
          container
          className="styled-scroll-transparent-desktop"
          sx={styles.container}>
          <Grid container item sx={styles.header}>
            <Logo />
            <IconButton sx={styles.closeIcon} onClick={onClose}>
              <Close />
            </IconButton>
          </Grid>
          <Grid container item sx={styles.titleContainer}>
            <Typography sx={styles.title}>SOLICITAÇÃO DE CONTATO</Typography>
          </Grid>
          <Grid container item sx={styles.buttonsContainer} gap={2}>
            <Input
              label={'Nome'}
              name="nome"
              type="text"
              value={contato.nome || ''}
              autoCapitalize="on"
              placeholder={'Nome completo'}
              disabled
            />
            <InputMask
              label={'Telefone'}
              name="telefone"
              type="tel"
              value={contato.telefone || ''}
              mask={Masks.telelefone}
              placeholder={'Digite seu número de telefone'}
              disabled
            />
            <Input
              label={'E-mail'}
              name="email"
              type="email"
              value={contato.email || ''}
              autoComplete="email"
              placeholder={'Digite seu e-mail'}
              disabled
            />
            <Input
              label={'Tipo'}
              name="tipo"
              placeholder={'Digite o tipo do assunto'}
              value={tipoContato[contato.tipo] || ''}
              disabled
            />
            <Input
              label={'Assunto'}
              name="mensagem"
              type="text"
              value={contato.mensagem || ''}
              autoCapitalize="on"
              placeholder={'Digite o assunto'}
              multiline
              rows={3}
              disabled
            />
            <Button id="primary" onClick={handleConcluirContato}>
              CONCLUIR SOLICITAÇÃO
            </Button>
          </Grid>
        </Grid>
      </Slide>
    </Modal>
  );
}

const styles = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    position: 'relative',
    maxHeight: '696px',
    maxWidth: '683px',
    height: '80%',
    width: '40%',
    borderRadius: '6px',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    padding: 3,
    zIndex: (theme) => theme.zIndex.modal,
    background: (theme) => theme.palette.blackSecundary,
    boxShadow: '0px 0px 134.60001px 0px rgba(255, 204, 41, 0.25)',
    outline: 'none',
    overflowY: 'auto',

    '@media (max-width: 900px)': {
      width: '90%',
    },
  },
  header: {
    flexGrow: 0,
    justifyContent: 'center',
    svg: {
      color: '#fff',
    },
  },
  titleContainer: {
    flexGrow: 0,
    justifyContent: 'center',
    padding: '16px 0',
    maxWidth: '420px',

    '@media (max-width: 1200px)': {
      padding: '16px 0',
    },
  },
  closeIcon: {
    position: 'absolute',
    top: '28px',
    right: '28px',
    width: '32px',
    height: '32px',
  },
  title: {
    color: '#FFF',
    textAlign: 'center',
    fontFamily: 'Now',
    fontSize: '24px',
    fontWeight: '700',
    textTransform: 'uppercase',

    '@media (max-width: 1200px)': {
      fontSize: '20px',
    },
  },
  subtitle: {
    color: '#E3E3E3',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontWeight: '500',

    '@media (max-width: 1200px)': {
      fontSize: '14px',
    },
  },
  buttonsContainer: {
    maxWidth: '420px',
    flexDirection: 'column',
    width: '100%',
    paddingBottom: '16px',
  },
  button: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #fff',
    width: '100%',
    height: '100%',

    '@media (max-width: 1200px)': {
      flexDirection: 'row',
    },

    '.MuiTypography-root': {
      color: '#fff',
      textTransform: 'none',
      fontSize: '16px',
      lineHeight: '38px',
      fontWeight: '500',
    },
  },
  buttonIconAtleta: {
    width: '28px',
    height: '28px',
  },
  buttonIconEmpresario: {
    width: '24px',
    height: '24px',
  },
};
